import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Details from './views/Details.vue';
import Public from './views/Public.vue';
import Admin from './views/Admin.vue';

Vue.use(Router);

export default new Router({
  routes: [{
    path: '/public',
    component: Public,
    children: [
      {
        path: 'ladder',
        name: 'Exec Comp Public Overview',
        component: Home,
      },
      {
        path: 'details',
        name: 'Exec Comp Public Details',
        component: Details,
      },
    ],
    beforeEnter: (to, from, next) => {
      next();
    },
  },
  {
    path: '/admin',
    component: Admin,
    name: 'Exec Comp Admin',
    beforeEnter: (to, from, next) => {
      next();
    },
  }],
});
